import getUploadCreds from "./get-upload-creds";
import { S3Client } from "@aws-sdk/client-s3";
import createCaseDef from "./create-casedef";
import UploadCaseDef from "../../types/UploadCaseDef";
import getRemoteUrl from "../../get-remote-url";

export default async function processAndUpload(
  caseDef: UploadCaseDef
  // userId: string
) {
  const uploadCredentials = await getUploadCreds();
  if (["aws", "r2"].includes(uploadCredentials.storageProvider)) {
    const s3ClientOptions: {
      region: string;
      credentials: {
        accessKeyId: string;
        secretAccessKey: string;
        sessionToken: string;
      };
      endpoint?: string;
    } = {
      credentials: {
        accessKeyId: uploadCredentials.accessKeyId,
        secretAccessKey: uploadCredentials.secretAccessKey,
        sessionToken: uploadCredentials.sessionToken,
      },
      region: uploadCredentials.region || "auto",
    };
    if (uploadCredentials.endpoint) {
      s3ClientOptions.endpoint = uploadCredentials.endpoint;
    }
    const s3Client = new S3Client(s3ClientOptions);

    const remoteCaseDef = await createCaseDef(
      caseDef,
      uploadCredentials,
      s3Client
      // userId
    );
    return getRemoteUrl(`viewer/case/${remoteCaseDef.shortid}`);
  } else if (uploadCredentials.storageProvider === "litevna") {
    const remoteCaseDef = await createCaseDef(caseDef, uploadCredentials);
    return getRemoteUrl(`viewer/case/${remoteCaseDef.shortid}`);
  } else {
    throw new Error("Unknown storage provider");
  }
}
